import h from "trader-hyperscript";
import { renderTableDownloadLinks } from "../../client/downloadtable";

export function render(opts: { tableId: string }): HTMLElement | HTMLElement[] {
  return (
    <div style="text-align: right">
      {renderTableDownloadLinks({
        tableid: opts.tableId,
        filename: "Classy Vragenlijst",
      })}
    </div>
  );
}
